// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"132":"2b1486d938488cb8","294":"b5449a637fa3c762","608":"dceff0265c8b3321","765":"6ea9a47eaab3f809","784":"31f2fd26fc473de8","793":"42ef63b7ec463244"}[chunkId] + ".js";
};